import { createContext, useContext } from 'react';

export const MapLegendContext = createContext(null);

export function useMapLegend() {
    return useContext(MapLegendContext);
}
